<template>
  <v-textarea
    :counter="counter"
    :disabled="disabled"
    :rules="ruleList"
    outlined
    v-model="value"
  ></v-textarea>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  mixins: [formElementMixin],
  props: {
    counter: {
      type: Number,
    },
  },
};
</script>
